import "./LoadingDots.css";
import React from "react";

export const LoadingDots = () => (
  <span className="LoadingDots">
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </span>
);

export const LoadingText = ({ className = "", text = "Laster" }) => {
  const classes = `${className} LoadingText`;
  return (
    <span className={classes}>
      {text}
      <LoadingDots />
    </span>
  );
};

export default LoadingText;
